<template>
    <modal :id="id" :loading="loading" :saveing="saveing" @shown="shown" @ok="save" @cancel="cancel">
        <span slot="modal-title">項目</span>
        <div class="row">
            <div class="col-md-4 col-sm-12">
                <form-select v-model="vm.Type" id="Type" label="項目">
                    <div is="option" value="3-4">3-4</div>
                    <div is="option" value="5-1">5-1</div>
                </form-select>
            </div>
            <div class="col-md-2 col-sm-12">
                <label>條件1</label>
                <label class="form-control">
                    <label>
                        <input type="checkbox" v-model="vm.MinEqual" value="true" />
                        ><span v-if="vm.MinEqual">=</span>
                    </label>
                </label>
            </div>
            <div class="col-md-2 col-sm-12">
                <form-input v-model="vm.Min" id="Min" label="條件2" type="number" required></form-input>
            </div>
            <div class="col-md-4 col-sm-12">
                <form-input v-model="vm.Score" id="Score" label="點數" type="number" required></form-input>
            </div>
        </div>
    </modal>
</template>

<script>
    import { detail } from '@/views';
    export default detail({
        name: 'pasetDetail',
        api: '/api/paset/',
    });
</script>

<style>
</style>